import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { apiClient } from '../../../api/client/axios';
import { showSnackbar } from '../../../store/snackbarSlice';

const fetchMeter = async (query) => {
  const { data } = await apiClient.get(`/meters/${query.queryKey[1]}`);
  return data;
};

export const useGetMeterHandler = (id) => {
  const dispatch = useDispatch();
  const [meter, setMeter] = useState(undefined);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['meter', id],
    queryFn: fetchMeter,
    enabled: Boolean(id),
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (data) setMeter(data);
  }, [data]);

  useEffect(() => {
    if (!isError) return;
    if (error instanceof AxiosError) {
      dispatch(showSnackbar({ message: error.response?.data?.message || error.message, severity: 'error' }));
      return;
    }
    dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
  }, [dispatch, error, isError]);

  return { meter, isLoading };
};
